import React from "react";
import Image from "../Image/Image";
import parseHTML from "../../helpers/parseHTML";
import { GlobalContext } from "../../context/GlobalContext";
import Fox from "../../../src/FoxDark.PNG";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faYoutube,
  faInstagram,
  faDiscord,
} from "@fortawesome/free-brands-svg-icons";

function Author({ data, visible, setVisible }) {
  const { isMobile } = React.useContext(GlobalContext);

  //* useEffect to prevent overflow if Author is visible
  React.useEffect(() => {
    if (visible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [visible]);

  //* if mobile device return offcanvas from bottom
  if (isMobile)
    return (
      <div
        className={`offcanvas offcanvas-bottom article-secondary-mobile ${
          visible && "article-secondary-visible show"
        }`}
        tabIndex="-1"
        id="offcanvasBottom"
        aria-labelledby="offcanvasLabel"
      >
        <div className="offcanvas-header">
          <button
            type="button"
            className="btn-close-custom dismiss-active-or-focus"
          >
            <i
              className="icon-click icon-close bi bi-x-lg text-muted"
              onClick={() => setVisible((prev) => !prev)}
            />
          </button>
        </div>
        <div className="offcanvas-body article-secondary-scroll">
          <div className="article-secondary-info">
            <Image source={data?.logo || Fox} className="article-logo" />

            <h4 className="text-dark text-muted text-truncate">{data?.name}</h4>

            <div
              id="data-description"
              className="text-muted text-left article-base-description-active"
            >
              {data?.description && parseHTML(data?.description)}
            </div>
            <div id="data-socialmedia" className="author-refIcon text-muted">
              {data?.socialmedia &&
                Object.entries(data?.socialmedia)
                  ?.reverse()
                  ?.map((el, index) => {
                    switch (el[0]) {
                      case "instagram":
                        return (
                          <a
                            key={index}
                            href={el?.[1]}
                            target="_blank"
                            className="text-muted"
                          >
                            <FontAwesomeIcon icon={faInstagram} />
                          </a>
                        );

                      case "discord":
                        return (
                          <a
                            key={index}
                            href={el?.[1]}
                            target="_blank"
                            className="text-muted"
                          >
                            <FontAwesomeIcon icon={faDiscord} />
                          </a>
                        );

                      default:
                        return null;
                    }
                  })}
            </div>
          </div>
        </div>
      </div>
    );

  //* else return offcanvas from right
  return (
    <div
      className={`offcanvas offcanvas-end article-secondary  ${
        visible && "article-secondary-visible show"
      }`}
      tabIndex="-1"
      id="offcanvas"
      aria-labelledby="offcanvasLabel"
    >
      <div className="offcanvas-header">
        <button
          type="button"
          className="btn-close-custom dismiss-active-or-focus"
        >
          <i
            className="icon-click icon-close bi bi-x-lg text-muted"
            onClick={() => setVisible((prev) => !prev)}
          />
        </button>
      </div>
      <div className=" article-secondary-scroll">
        <div className="article-secondary-info">
          <Image source={data?.logo || Fox} className="article-logo" />

          <h4 className="text-dark text-muted text-truncate">{data?.name}</h4>

          <div
            id="data-description"
            className="text-muted text-justify article-base-description-active"
          >
            {data?.description && parseHTML(data?.description)}
          </div>
          <div id="data-socialmedia" className="author-refIcon text-muted">
            {data?.socialmedia &&
              Object.entries(data?.socialmedia)
                ?.reverse()
                ?.map((el) => {
                  switch (el[0]) {
                    case "instagram":
                      return (
                        <a
                          href={el?.[1]}
                          target="_blank"
                          className="text-muted"
                        >
                          <FontAwesomeIcon icon={faInstagram} />
                        </a>
                      );

                    case "discord":
                      return (
                        <a
                          href={el?.[1]}
                          target="_blank"
                          className="text-muted"
                        >
                          <FontAwesomeIcon icon={faDiscord} />
                        </a>
                      );

                    default:
                      return null;
                  }
                })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Author;
